import { Trans, useTranslation } from 'react-i18next';
import React from 'react';

import { OnboardingStyle } from '../../../public/onboarding/onboarding-style';
import { AuthHeader } from '../../../../global-styles/layout';
import { Heading2Text, Subhead02Text } from '../../../../components/typography/typography';
import Resume from '../../../../components/common/resume/Resume';
import { images } from '../../../../assets/images/images';
import { TracingPolicyStyle } from './tracing-policy-style';

const TracingPolicy: React.FC<any> = ({ form, isGeolocation = false }) => {
  const { t } = useTranslation(['common', 'auth']);

  return (
    <>
      <TracingPolicyStyle>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title">
                {!isGeolocation ? (
                  <>
                    <Heading2Text as="h1" weight={600} color="">
                      Mobility
                    </Heading2Text>

                    <Subhead02Text>
                      <Trans t={t} i18nKey={''}>
                        Acceda al seguimiento del servicio
                      </Trans>
                    </Subhead02Text>

                    <Subhead02Text>
                      <Trans t={t} i18nKey={''}>
                        Si es posible, enviaremos la geolocalización de su grúa para que pueda visualizar el trayecto y
                        el tiempo de llegada de la misma.
                      </Trans>
                    </Subhead02Text>
                  </>
                ) : (
                  <>
                    <Heading2Text as="h1" weight={600} color="">
                      Bievenido a:
                      <br />
                      Mobility GEO
                    </Heading2Text>

                    <Subhead02Text>
                      <Trans t={t} i18nKey={''}>
                        Indíquenos dónde se encuentra para poder enviar su grúa
                      </Trans>
                    </Subhead02Text>
                  </>
                )}
              </div>
            </AuthHeader>

            <div className="container-image">
              <img src={images.cars} alt="" />
            </div>

            <Resume form={form} canEdit={true} />
          </div>
        </OnboardingStyle>
      </TracingPolicyStyle>
    </>
  );
};

export default TracingPolicy;
